/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function(){
  "use strict";

    jQuery(document).ready(function($){

      $(document).ready(function(e) {
        owlSetup();
      });
      $(window).resize(function() {
        owlSetup();
      });

      /*
       * Initializes all owl carousels with the .owl-initialize class
       * data attribute data-carousel-display controls when the carousel displays based on breakpoint
       * format data-carousel-display='{"action":"create","breakpoint":768}'
       * "action" accepts create or destroy
       * "breakpoint" accepts pixel value of breakpoint - no units
       * data-carousel-display='{"action":"create","breakpoint":768}' means the slides will only be made into a carousel above 768px
       * data-carousel-display='{"action":"destroy","breakpoint":992}' means the carousel effect will be removed above 992px
       */
      function owlSetup() {
        var oc = $('.owl-initialize');
        oc.each(function () {
          var $el = $(this);
      
          let carouselDisplay = $el.data('carousel-display');
          if( carouselDisplay ) {
            // Has display data attribute
            let displayAction = carouselDisplay['action'];
            let displayBreakpoint = parseInt(carouselDisplay['breakpoint']);
            let matchMedia = '';
      
            if( !isNaN(displayBreakpoint) && ( displayAction == 'create' || displayAction == 'destroy' ) ) {
      
              // The breakpoint is a number and action with either create or destroy
              if( displayAction == 'create' ) {
                matchMedia = '(max-width: ' + displayBreakpoint + 'px)';
              } else if( displayAction == 'destroy' ) {
                displayBreakpoint = displayBreakpoint - 1;
                matchMedia = '(min-width: ' + displayBreakpoint + 'px)';
              }
      
              if (window.matchMedia(matchMedia).matches) {
                // Destroy Owl Carousel on when critera are matched
                if (typeof $el.data('owl.carousel') != 'undefined') {
                    $el.data('owl.carousel').destroy();
                }
                $el.removeClass('owl-carousel');
              } else {
                owlInitialize($el);
              }
      
            } else {
              // carousel-display values were not valid, show carousel
              owlInitialize($el);
            }
      
          } else {
            // no carousel-display options, show carousel
            owlInitialize($el);
          }
        });
      }
      
      /* Runs the owl carousel if total item width is less than its parent/container width */
      function owlInitialize($carousel) {
        setTimeout(function() {
          $carousel.addClass('owl-carousel');
          $carousel.owlCarousel($.extend({
              autoplay: true,
              loop: true,
              items: 3,
              autowidth: true,
              nav: false,
              dots: true
          }, $carousel.data('carousel-options')));

          //console.log($carousel.data('carousel-options'));
      
          // Calculate the total width of the carousel items without clones
          let totalWidth = 0;
          $carousel.find('.owl-item:not(".cloned")').each(function() {
              totalWidth += $(this).width();
          });
          console.log(totalWidth);
          let parentWidth = $carousel.parent().width();
          if ( totalWidth <= parentWidth ) {
            // Destroy Owl Carousel on desktop
            if (typeof $carousel.data('owl.carousel') != 'undefined') {
                $carousel.data('owl.carousel').destroy();
            }
            $carousel.removeClass('owl-carousel');
          }
      
        }, 10);
      }

      /*
       * Cart Upsell (Sidecart): add-to-cart handler for offer cards, and carousel init.
       *
       * The add-to-cart call and the discount-apply call must run in *sequence*, not in
       * parallel: firing /discount/{code} before the browser has processed /cart/add.js's
       * Set-Cookie response can have Shopify operate on a stale cart session, which was
       * observed to silently drop the just-added item. Only once the add is confirmed do we
       * apply the code, and only then dispatch "product:added" - that event triggers the
       * cart drawer's re-render immediately, so the discount must already be active on the
       * session by that point or the drawer would render at full price.
       */
      $(document).on('click', '[data-action="add-upsell-item"]', function(e) {
        e.preventDefault();

        var $button = $(this);
        var variantId = $button.data('variant-id');
        var discountCode = $button.data('discount-code');
        var triggerProductId = $button.data('trigger-product-id');

        if (!variantId) {
          return;
        }

        $button.prop('disabled', true);

        fetch(window.routes.cartAddUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: { '_upsell': 'true', '_upsell_trigger_id': String(triggerProductId) }
          })
        }).then(function(addResponse) {
          if (!addResponse.ok) {
            return Promise.reject();
          }

          if (discountCode) {
            return fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' });
          }
        }).then(function() {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: { id: variantId },
              quantity: 1
            }
          }));
        }).catch(function() {
          // Add-to-cart failed; nothing to do beyond re-enabling the button below.
        }).then(function() {
          $button.prop('disabled', false);
        });
      });

      /*
       * The Sidecart is re-rendered by fetching fresh HTML from Shopify and swapping it into
       * the DOM (see CartSection._replaceContent in theme.min.js). That swap happens *after*
       * the "product:added"/"cart:refresh" events fire and dispatches no event of its own when
       * done, so a MutationObserver is the reliable way to know new offer markup has landed.
       * Scoped to .CartUpsell__Carousel only (rather than reusing the global owlSetup() above)
       * so cart updates don't re-trigger unrelated Owl Carousels elsewhere on the page.
       */
      function initCartUpsellCarousels() {
        $('.CartUpsell__Carousel:not(.owl-carousel)').each(function() {
          $(this).addClass('owl-carousel').owlCarousel({
            items: 1,
            nav: true,
            dots: false,
            loop: false,
            autoplay: false
          });
        });
      }

      var sidebarCartElement = document.getElementById('sidebar-cart');

      if (sidebarCartElement) {
        new MutationObserver(initCartUpsellCarousels).observe(sidebarCartElement, { childList: true, subtree: true });
      }

      initCartUpsellCarousels();

  });

})();